
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/asset/staking",
      function () {
        return require("private-next-pages/asset/staking/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/asset/staking"])
      });
    }
  